module.exports = __webpack_public_path__ + "img/masterKongBg.a9ac0f00.png";